import React, { useState } from 'react';
import styled from 'styled-components';
import { userInfo } from '../../../../../models/entities/user';
import Button from '../../../../shared/SmallComponents/Button';
import AddPlatformAdminModal from './AddPlatformAdminModal';
import { PlatformActions, PlatformHeaderRow, PlatformPageSubtitle, PlatformPageTitle } from '../../shared/platformPageStyles';

type Props = {
    localization: any;
    showLoader: boolean;
    users: userInfo[];
    onRefresh: () => void;
    onAdd: (email: string) => Promise<void>;
};

const PlatformSuperAdminsPageHeader = ({ localization, showLoader, users, onRefresh, onAdd }: Props) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Wrapper>
            <PlatformHeaderRow>
                <div>
                    <PlatformPageTitle>{localization.header.title}</PlatformPageTitle>
                    <PlatformPageSubtitle>{localization.header.subtitle}</PlatformPageSubtitle>
                </div>
                <PlatformActions>
                    <Button
                        width="auto"
                        height="auto"
                        buttonType="hollow"
                        padding="0 8px"
                        margin="4px"
                        onClick={() => setModalOpen(true)}
                    >
                        <span className="material-icons">add</span>
                        <span>{localization.header.add_btn}</span>
                    </Button>
                    <Button width="auto" height="auto" buttonType="hollow" padding="0 8px" margin="4px" onClick={onRefresh}>
                        <span className="material-icons">refresh</span>
                    </Button>
                </PlatformActions>
            </PlatformHeaderRow>
            <AddPlatformAdminModal
                visible={modalOpen}
                localization={localization}
                loading={showLoader}
                users={users}
                onCancel={() => setModalOpen(false)}
                onSubmit={async (email) => {
                    await onAdd(email);
                    setModalOpen(false);
                }}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 100%;
`;

export default PlatformSuperAdminsPageHeader;
